import React from 'react'
import { Carousel, Button, Progress, Icon, Modal } from 'antd'
import { RouteComponentProps } from 'react-router'
import { ComponentExt } from 'util/reactExt'
import { filter } from 'lodash'
import * as styles from './index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {
  renderPage: any
  warningState: boolean
  ruleState: boolean
  sectionList: any
  userClass: any
  studyStatus: {
    status: number
    time: number
  }
  promoteMsg: any
  bannerList: any
  time: number
}

class Study extends ComponentExt<IProps, IState> {
  state = {
    renderPage: '',
    warningState: false,
    ruleState: false,
    sectionList: [],
    userClass: {
      img: '',
      name: '',
    },
    studyStatus: {
      status: 1,
      time: 0,
    },
    promoteMsg: [],
    bannerList: [],
    time: 0,
  }

  private timer

  componentDidMount() {
    clearTimeout(this.timer)
    this.handleStudySection()
    this.handleStudyUserClass()
    this.handleStudyStatus()
    this.handleStudyPromoteMsg()
    this.fetchBanner()
  }

  async fetchBanner() {
    const bannerList = await this.api.banner.getHomeBannerList(5000105)
    this.setState({ bannerList })
  }

  // 章节列表
  handleStudySection = async () => {
    try {
      const sectionList = await this.api.lecturer.getLecturerStudySection({})
      this.setState({
        sectionList,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  // 投顾等级
  handleStudyUserClass = async () => {
    try {
      const id = await this.api.lecturer.getLecturerStudyClass({})
      const list = await this.api.lecturer.getLecturerGloryTabList({})
      const userClass: object = filter(list, { id })[0]
      this.setState({ userClass })
    } catch (err) {
      console.error(err.message)
    }
  }

  // 考核状态
  handleStudyStatus = async () => {
    try {
      const studyStatus = await this.api.lecturer.getLecturerStudyStatus({})
      this.setState({ studyStatus })
      if (studyStatus.status === 2) {
        this.setState(
          {
            time: studyStatus.time,
          },
          () => {
            this.timer = setInterval(() => {
              if (this.state.time > 0) {
                this.setState({ time: this.state.time - 1 })
              } else {
                this.handleStudyStatus()
                clearInterval(this.timer)
              }
            }, 1000)
          },
        )
      }
    } catch (err) {
      console.error(err.message)
    }
  }

  handleStudyPromoteMsg = async () => {
    try {
      const promoteMsg = await this.api.lecturer.getLecturerStudyPromoteMsg({})
      this.setState({ promoteMsg })
    } catch (err) {
      console.error(err.message)
    }
  }

  hideRuleModal = () => {
    this.setState({
      ruleState: false,
    })
  }

  hideWarningModal = () => {
    this.setState({
      warningState: false,
    })
  }

  // 开启考核
  clickStartStudy = (studyStatus: any) => {
    const { status } = studyStatus
    if (status === 1) {
      this.setState({ warningState: true })
    }
  }

  // 确认开启
  clickConfirmStart = async () => {
    const { status, msg } = await this.api.lecturer.getLecturerStudyOpenAssess(
      {},
    )
    if (status === 1) {
      this.setState({
        warningState: false,
      })
      this.handleStudySection()
      this.handleStudyStatus()
      this.$message.success(msg)
    } else {
      this.$message.error(msg)
    }
  }

  // 去学习
  gotostudy = async ({ id }) => {
    try {
      const {
        msg,
        status,
      } = await this.api.lecturer.getLecturerStudyOpenAssessSection({ id })
      if (status === 1) {
        this.$message.success(msg)
        this.props.history.push(`coursecheck?id=${id}`)
      } else if (status === 3 || status === 6 || status === 7) {
        this.props.history.push(`coursecheck?id=${id}`)
      } else if (status === 2 || status === 4 || status === 5) {
        this.$message.warning(msg)
      } else {
        this.$message.error(msg)
      }
    } catch (err) {
      console.error(err.message)
    }
  }

  render() {
    const {
      time,
      warningState,
      ruleState,
      sectionList,
      userClass,
      promoteMsg,
      studyStatus,
      bannerList,
    } = this.state

    const ProgressFn = section => {
      const { report } = section
      if (section.is_study === 3) {
        return 100
      }
      if (report) {
        return Math.floor((report.had / report.all) * 100)
      } else {
        return 0
      }
    }

    const sectionFn = item => {
      let conf: { text: string; disabled: boolean } = {
        text: '待开始',
        disabled: true,
      }
      if (item.is_study === 2) {
        conf = {
          text: '正在学习',
          disabled: false,
        }
      } else if (item.is_study === 3) {
        conf = {
          text: '继续学习',
          disabled: false,
        }
      } else if (item.is_study === 4) {
        conf = {
          text: '开始学习',
          disabled: false,
        }
      }

      return (
        <Button
          type="primary"
          onClick={() => {
            this.gotostudy(item)
          }}
          style={{ minWidth: 88, float: 'right', margin: '17px 0' }}
          disabled={conf.disabled}
        >
          {conf.text}
        </Button>
      )
    }

    const formatFn = val => {
      if (val < 0) {
        val = 0
      }
      return ('0' + val).slice(-2)
    }

    const startStudyFn = () => {
      const { status } = studyStatus
      let btnConf: any = {
        type: 'primary',
        text: '已完成考核',
        icon: true,
        disabled: true,
        style: {
          backgroundColor: '#73cc5d',
          color: '#fff',
          border: 'none',
        },
      }

      if (status === 1) {
        btnConf = {
          type: 'primary',
          text: '开启考核',
          icon: false,
          disabled: false,
          style: {},
        }
      }

      if (status === 2) {
        const days = Math.floor(time / (60 * 60 * 24))
        const hours = Math.floor((time / (60 * 60)) % 24)
        const minutes = Math.floor((time / 60) % 60)
        const seconds = Math.floor(time % 60)
        btnConf = {
          type: 'Default',
          text: `剩余：${formatFn(days)}天${formatFn(hours)}小时${formatFn(
            minutes,
          )}分${formatFn(seconds)}秒`,
          icon: false,
          disabled: true,
          style: {
            color: '#3a9cff',
            borderColor: '#3a9cff',
          },
        }
      }

      return (
        <Button
          type={btnConf.type}
          size="large"
          disabled={btnConf.disabled}
          style={btnConf.style}
          onClick={() => {
            this.clickStartStudy(studyStatus)
          }}
        >
          <Icon
            type="check-circle"
            style={{
              verticalAlign: 'middle',
              display: btnConf.icon ? 'inline-block' : 'none',
            }}
          />
          <span style={{ verticalAlign: ' middle' }}>{btnConf.text}</span>
        </Button>
      )
    }

    return (
      <div className={`${styles.wrapper} studyWrapper`}>
        <div className={styles.banner}>
          <div className="banner">
            <Carousel>
              {bannerList.map(banner => (
                <div key={banner.img_url}>
                  <img src={banner.img_url} alt={banner.remark} />
                </div>
              ))}
            </Carousel>
          </div>
          <div className={styles.broadcast}>
            <div className={styles.title}>
              <Icon type="sound" />
              <span>考核动态</span>
            </div>
            <Carousel dotPosition="left" dots={false} autoplay>
              {promoteMsg.map(item => (
                <p key={item}>{item}</p>
              ))}
            </Carousel>
          </div>
        </div>

        <div className={styles.main}>
          <div className={styles.title}>
            <div className={styles.explain}>
              <img src={userClass.img} className={styles.classImg} alt="" />
              <div className={styles.text}>
                <h3>当前等级：{userClass.name}</h3>
                <Button
                  type="link"
                  style={{ padding: 0, color: '#3a9cff' }}
                  onClick={() => {
                    this.setState({ ruleState: true })
                  }}
                >
                  进阶说明
                </Button>
                <div className="studyRule">
                  <Modal
                    title="进阶说明"
                    centered={true}
                    visible={ruleState}
                    onCancel={this.hideRuleModal}
                    getContainer={(): any =>
                      document.getElementsByClassName('studyRule')[0]
                    }
                    footer={[]}
                  >
                    <p>
                      开启考核后，你需要在规定时间内完成对应视频学习，若未能及时完成，考核进度清零，你是否准备好接受考核了?
                    </p>
                  </Modal>
                </div>
              </div>
            </div>
            <div className="studyBtnWrap">
              {startStudyFn()}
              <Modal
                title="确认考核"
                centered={true}
                visible={warningState}
                onCancel={this.hideWarningModal}
                okText="确认考核"
                onOk={this.clickConfirmStart}
                getContainer={(): any =>
                  document.getElementsByClassName('studyBtnWrap')[0]
                }
              >
                <p>
                  开启考核后，你需要在规定时间内完成对应视频学习，若未能及时完成，考核进度清零，你是否准备好接受考核了?
                </p>
              </Modal>
            </div>
          </div>

          <ul className={styles.topic}>
            {sectionList.map(i => (
              <li key={i.id}>
                <Progress
                  className={styles.progress}
                  style={{ color: '#000' }}
                  type="circle"
                  percent={ProgressFn(i)}
                  width={24}
                  strokeWidth={8}
                  strokeColor={{ '0%': '#3a9cff', '100%': '#3a9cff' }}
                />
                <div className={styles.text}>
                  <p>{i.name}</p>
                  <span
                    className={
                      {
                        软件: styles.stock,
                        股票: styles.software,
                      }[i.label_name]
                    }
                  >
                    {i.label_name}
                  </span>
                </div>
                {sectionFn(i)}
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default Study
